import { HttpErrorResponse } from '@angular/common/http';
import { Component, HostBinding, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { filterAnimation, pageAnimations } from '../../../../animations/page.animation';
import { CLPUser, UserResponse } from '../../../../models/clpuser.model';
import { eFeatures, eUserRole } from '../../../../models/enum.model';
import { Lead, LeadListResponse } from '../../../../models/lead.model';
import { RoleFeaturePermissions } from '../../../../models/roleContainer.model';
import { GlobalService } from '../../../../services/global.service';
import { LeadSettingService } from '../../../../services/leadSetting.service';
import { NotificationService } from '../../../../services/notification.service';
import { LocalService } from '../../../../services/shared/local.service';
import { UtilityService } from '../../../../services/shared/utility.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ClpCompany } from '../../../../models/company.model';

@Component({
    selector: 'contact-recent-lead',
    templateUrl: './contact-recent-lead.component.html',
    styleUrls: ['./contact-recent-lead.component.css'],
    animations: [pageAnimations, filterAnimation]
})
export class ContactRecentLeadComponent {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    recentLeadListSource: MatTableDataSource<any>;
    recentLeadListDisplayColumns: string[];
    @Input() loggedUser: CLPUser;
    @Input() ownerId: number = 0;
    @Input() companyData: ClpCompany;
    userResponse: UserResponse;
    roleFeaturePermissions: RoleFeaturePermissions;
    showEmailComponent: boolean = false;
    @HostBinding('@pageAnimations') public animatePage = true;
    showAnimation = -1;
    private encryptedUser: string = '';
    showSpinner: boolean = false;

    recentLeadList: Lead[];
    columns = [{ field: '$', title: '', width: '30' },
    { field: '$$', title: ' ', width: '40' },
    { field: 'leadDesc', title: 'Lead', width: '200' },
        { field: 'leadStatusCode', title: 'Status', width: '50' },
        { field: 'action', title: 'Action', width: '50' }
    ];
    reorderColumnName: string = 'leadDesc';
    constructor(
        private _router: Router,
        public _localService: LocalService,
        public _leadSettingService: LeadSettingService,
        private _utilityService: UtilityService,
        private _globalService: GlobalService,
        public notifyService: NotificationService) {
    }

    ngOnInit() {
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(() => {
                    if (this.loggedUser) {
                        this.getRecentLeadList();
                    }
                    else
                        this._router.navigate(['/login']);
                });
            }
            else
                this._router.navigate(['/login']);
        })
    }

    private async authenticateR() {
        this.showSpinner = true;
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.None)
            .then(async (result: UserResponse) => {
                if (result) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    this.userResponse = UtilityService.clone(result);
                    if (!isNullOrUndefined(this.userResponse)) {
                        if (!isNullOrUndefined(this.userResponse?.user)) {
                            this.loggedUser = this.userResponse.user;
                            this.roleFeaturePermissions = this.userResponse.roleFeaturePermissions;
                            if (this.loggedUser?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-recent-lead.authenticateR", err.message, null,
                    'Feature: ' + eFeatures.None
                );
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    getRecentLeadList() {
        this._leadSettingService.getLeadListByContactId(this.encryptedUser, this.ownerId)
            .then(async (result: LeadListResponse) => {
                if (result) {
                    this.recentLeadList = UtilityService.clone(result?.leads);
                    this.setGrid(this.recentLeadList);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-recent-lead.getRecentLeadList", err.message, null,
                    'ownerId: ' + this.ownerId
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    closeEmailBox(value) {
        this.showEmailComponent = value;
    }

    public gotoLink(columnName, dataItem) {
        switch (columnName) {
            case "userName":
                return `/edit-profile/${dataItem?.cLPUserID}`;
            case "lead":
                return `/lead-detail/${dataItem?.leadID}`;
            default: {
                break;
            }
        }
    }

    resetChildForm() {
        this.showEmailComponent = false;
        this.addTimeout(() => { this.showEmailComponent = true }, 100);
    }

    getTooltip(dataItem) {
        const nameAnchor = dataItem?.ulastName ? dataItem?.ulastName : '' + '\n' + dataItem?.leadDesc + 'Contact : ' + dataItem?.contactID + '\n' + 'Status :' + dataItem?.leadStatusCode;
        return nameAnchor;
    }

    setGrid(list) {
        this.recentLeadListDisplayColumns = this.columns.map(c => c.field);
        this.recentLeadListSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.recentLeadListSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('lead_grid') ? this._localService.getPageSize('lead_grid'): 50;
            }
            if (this.sort) {
                this.recentLeadListSource.sort = this.sort;
                const sortState: Sort = this._localService.getSortState('lead_grid');
                this.sort.active = sortState?.active;
                this.sort.direction = sortState?.direction;
                this.sort.sortChange.emit(sortState);
            }
        }, 500)
    }

    getSerialNumber(index: number): number {
        return index + 1 + (this.paginator?.pageIndex || 0) * (this.paginator?.pageSize || 5);
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

    ngOnDestroy() {
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }
}
